const SPRING_COLOR = '#90EE90'
const SUMMER_COLOR = '#FFD700'
const AUTUMN_COLOR = '#FF8C00'
const WINTER_COLOR = '#87CEEB'

// Season data for inner ring
export const seasons = [
  { label: 'seasons.spring', value: 92, color: SPRING_COLOR },
  { label: 'seasons.summer', value: 92, color: SUMMER_COLOR },
  { label: 'seasons.autumn', value: 91, color: AUTUMN_COLOR },
  { label: 'seasons.winter', value: 90, color: WINTER_COLOR },
]

// Month data for outer ring
export const months = [
  { label: 'months.march', value: 31, color: '' },
  { label: 'months.april', value: 30, color: SPRING_COLOR },
  { label: 'months.may', value: 31, color: '' },
  { label: 'months.june', value: 30, color: '' },
  { label: 'months.july', value: 31, color: SUMMER_COLOR },
  { label: 'months.august', value: 31, color: '' },
  { label: 'months.september', value: 30, color: '' },
  { label: 'months.october', value: 31, color: AUTUMN_COLOR },
  { label: 'months.november', value: 30, color: '' },
  { label: 'months.december', value: 31, color: '' },
  { label: 'months.january', value: 31, color: WINTER_COLOR },
  { label: 'months.february', value: 28, color: '' },
]
